/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) 2020 Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  successfullyLoggedIn: '登录成功',
  failedToLogIn: '账号或密码错误，请重试',
  successfullyLoggedOut: '您已成功登出账号',
  failedToLogOut: '登出失败，请重试',
  successfullyRecoveredPassword: '您的密码已成功恢复！请检查您的电子邮件获得更多内容',
  failedToRecoverPassword: '恢复密码时出现错误，请重试',
  invalidateSuccess: '成功清除缓存',
  sessionExpired: '您的会话已过期，请重新登录',
}
